import { Tab } from '../Tabs.types';

const findTabIndex = (routes: Tab[], currentTab?: Tab): number =>
  routes.findIndex((tab) => tab?.name === currentTab?.name);

export default findTabIndex;
